
// スクロールで .move クラスを追加
document.addEventListener("DOMContentLoaded", function () {
    const fadeInElements = document.querySelectorAll(".fadeIn.animation");
    fadeInElements.forEach((el, index) => {
        el.setAttribute("style", `--index:${index + 1};`);
    });
    function addMoveClassOnScroll() {
        const windowHeight = window.innerHeight;
        const animationElements = document.querySelectorAll(".animation");
        animationElements.forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top <= windowHeight * 0.9) {
                element.classList.add("move");
            }
        });
    }
    window.addEventListener("scroll", addMoveClassOnScroll);
    addMoveClassOnScroll();
});



// マウスストーカー
document.addEventListener("DOMContentLoaded", function () {
    const stalker = document.getElementById('mouse-stalker');
    const links = document.querySelectorAll('a');
    const textLinks = document.querySelectorAll('.text-list a'); 
    document.addEventListener('mousemove', function (e) {
        stalker.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    });

    links.forEach(link => {
        link.addEventListener('mouseenter', function () {
            stalker.classList.add('hover');
        });
        link.addEventListener('mouseleave', function () {
            stalker.classList.remove('hover');
        });
    });

    textLinks.forEach(link => {
        link.addEventListener('mouseenter', function () {
            stalker.style.display = 'none';
        });
        link.addEventListener('mouseleave', function () {
            stalker.style.display = '';
        });
    });
});



// カーソルに画像が追従 (TOPのCOLLABORATION)
document.addEventListener("DOMContentLoaded", () => {
    const cursorImage = document.getElementById("cursor-image");
    document.addEventListener("mousemove", (e) => {
        cursorImage.style.left = `${e.clientX}px`;
        cursorImage.style.top = `${e.clientY}px`;
    });
    document.querySelectorAll(".text-list a").forEach(link => {
        link.addEventListener("mouseover", (e) => {
            const imgSrc = e.currentTarget.getAttribute("data-img");
            cursorImage.style.backgroundImage = `url(${imgSrc})`;
            cursorImage.style.opacity = "1";
        });
        link.addEventListener("mouseout", () => {
            cursorImage.style.opacity = "0";
        });
    });
});

